// Auto generated file, do not manually modify!
// com.hotpads.capps.handler.web.landlord.v1.CappsLandlordInvitationsWebApiHandler

import { getClient } from '../../client';
import { httpFrontEndRequest } from '@zg-rentals/ts-client-http-client';

import type {
  GetApplicationLinkRequestDto,
  GetApplicationLinkResponseDto,
  InvitedApplicantsForListingResponseDto,
  InviteToApplyRequestDto,
  ListingAlias,
} from '../..';

interface GetInvitedApplicantsParams {
  listingAlias: ListingAlias;
}

export const CappsLandlordInvitationsWebApiHandler_getApplicationLink_Path =
  '/api/web/landlord/v1/applications/getApplicationLink';

export const CappsLandlordInvitationsWebApiHandler_getApplicationLink = (
  postData: GetApplicationLinkRequestDto,
  client = getClient(),
) => {
  return httpFrontEndRequest<never, GetApplicationLinkRequestDto, GetApplicationLinkResponseDto>(
    {
      endpoint: CappsLandlordInvitationsWebApiHandler_getApplicationLink_Path,
      method: 'POST',
      contextPath: '/capps',
      postData: postData,
    },
    client,
  );
};

export const CappsLandlordInvitationsWebApiHandler_getInvitedApplicants_Path =
  '/api/web/landlord/v1/applications/getInvitedApplicants';

export const CappsLandlordInvitationsWebApiHandler_getInvitedApplicants = (
  getParams: GetInvitedApplicantsParams,
  client = getClient(),
) => {
  return httpFrontEndRequest<GetInvitedApplicantsParams, never, InvitedApplicantsForListingResponseDto>(
    {
      getParams: getParams,
      endpoint: CappsLandlordInvitationsWebApiHandler_getInvitedApplicants_Path,
      method: 'GET',
      contextPath: '/capps',
    },
    client,
  );
};

export const CappsLandlordInvitationsWebApiHandler_inviteToApply_Path =
  '/api/web/landlord/v1/applications/inviteToApply';

export const CappsLandlordInvitationsWebApiHandler_inviteToApply = (
  postData: InviteToApplyRequestDto,
  client = getClient(),
) => {
  return httpFrontEndRequest<never, InviteToApplyRequestDto, void>(
    {
      endpoint: CappsLandlordInvitationsWebApiHandler_inviteToApply_Path,
      method: 'POST',
      contextPath: '/capps',
      postData: postData,
    },
    client,
  );
};
